export default "__VITE_ASSET__DWsZmTJp__"